const GROUP_ID_DEFAULT = "_____NOTHING_____";

class FirestoreDao {
  constructor(db, rootDoc, tmpOrders) {
    this.db = db;
    this.rootDoc = rootDoc;
    this.tmpOrders = tmpOrders;
  }

  base () {
    return this.db.doc(this.rootDoc);
  }

  findOrders () {
    return this.base().collection("orders");
  }

  async findMenus (publish) {
    // グルーピング前
    const menusQuery = this.base()
      .collection(`menus`)
      .where("publish", "==", publish ? true : false); // publish only
    const menusSS = await menusQuery.get();
    const menusData = menusSS.docs
      .map(docSS => docSS.data())
      .filter(data => "menuId" in data); // groups は除外
    // console.log(`menusData`, menusData);

    // グルーピング
    const groupMenuDatas = await this.createGroupMenuDatas(menusData);

    // グループ設定なし
    const noGroupMenuData = this.createNoGroupMenuData(menusData);

    // merge
    const mergedMenus = groupMenuDatas.concat([noGroupMenuData]);
    return mergedMenus;
  }

  async createGroupMenuDatas (menusData) {
    // グループデータ
    const menuGroups = await this.findMenuGroups();
    if (!menuGroups || menuGroups.length == 0) {
      return [];
    }
    const groups = menuGroups.groups;

    // グルーピング
    const newMenus = groups
      .sort((group1, group2) => group1.sort - group2.sort)
      .map((group) => {
        const groupId = group.id;
        const menus = menusData.filter((menu) => menu.groupIds.includes(groupId));

        // sort
        menus.sort((m1, m2) => {
          const m1Sort = m1.sorts.find(s => s.groupId === groupId);
          const m2Sort = m2.sorts.find(s => s.groupId === groupId);
          if (m1Sort.sort === m2Sort.sort) {
            // sort が同じ場合は updatedAt で比較
            const m1UpdatedAt = moment(m1.updatedAt.toDate());
            const m2UpdatedAt = moment(m2.updatedAt.toDate());
            return m1UpdatedAt.isBefore(m2UpdatedAt) ? 1 : -1;
          }
          return m1Sort.sort - m2Sort.sort;
        });
        // console.log(groupId, menus);

        return {
          group: group,
          menus: menus,
        };
      });
    return newMenus;
  }

  createNoGroupMenuData (menusData) {
    // カテゴリ未設定
    const noGroupMenus = menusData.filter(menu => menu.groupIds == null || menu.groupIds.length == 0);
    noGroupMenus.sort((m1, m2) => {
      // sort が同じ場合は updatedAt で比較
      const m1UpdatedAt = moment(m1.updatedAt.toDate());
      const m2UpdatedAt = moment(m2.updatedAt.toDate());
      return m1UpdatedAt.isBefore(m2UpdatedAt) ? 1 : -1;
    });

    // console.log(`noGroupMenus=${JSON.stringify(noGroupMenus)}`);
    const noGroupMenuData = {
      group: {
        id: GROUP_ID_DEFAULT,
        name: "その他",
        open: true,
        sort: 99999,
      },
      menus: noGroupMenus,
    };
    return noGroupMenuData;
  }

  // メニューグループ
  async findMenuGroups () {
    const docSS = await this.base()
      .collection("menus")
      .doc("groups")
      .get();
    const menuGroups = docSS.data();
    return menuGroups;
  }

  // メニュー詳細(新規)
  async findMenu (id) {
    const baseRef = this.base();
    const menuRef = baseRef.collection("menus").doc(id);

    let menuData = null;
    await menuRef.get().then(async (menuSS) => {
      if (menuSS.exists) {
        menuData = await this.createMergedMenuData(menuSS);
      }
    });
    return menuData;
  }

  async createMergedMenuData (menuSS) {
    const menuData = menuSS.data();

    const toppingsData = [];
    const toppings = menuData.toppings;
    for (const t of toppings) {
      const topping = await this.createToppingData(t.toppingRef);
      toppingsData.push(topping);
    }
    menuData.toppings = toppingsData;

    return menuData;
  }

  async createToppingData (toppingRef) {
    const doc = await toppingRef.get();
    if (!doc.exists) {
      return null;
    }
    let topping = doc.data();
    delete topping.menu; // 削除(ref)
    delete topping.toppingRef; // 削除(ref)

    // 選択肢
    const values = await this.createToppingValues(topping.values);
    topping.values = values.filter(value => value != null);

    // 選択肢 初期値 (先頭)
    if (values && values.length != 0) {
      topping.selected = values[0].id;
    }
    return topping;
  }

  async createToppingValues (orgValues) {
    const newValuesTasks = orgValues.map(async value => {
      if (!value.ref) {
        return value; // 手入力
      }

      // 参照メニュー
      const refMenuId = value.refMenuId;
      const menuRef = this.base().collection("menus").doc(refMenuId);
      const menuSS = await menuRef.get();
      if (!menuSS.exists) {
        return null; // 削除されている場合
      }

      // 必要な項目だけ抽出
      const refMenuData = menuSS.data();
      let newValue = {};
      newValue.id = value.id;
      newValue.refMenuId = refMenuId;
      newValue.name = refMenuData.name;
      newValue.provideStatus = refMenuData.provideStatus;
      newValue.amount = refMenuData.amountBaseEx; // 割引後の金額
      newValue.amountBase = refMenuData.amountBase;
      newValue.amountBaseEx = refMenuData.amountBaseEx;
      newValue.amountDiscount = refMenuData.amountDiscount;
      return newValue;
    });
    const newValues = await Promise.all(newValuesTasks);
    console.log("@newValues", newValues);
    return newValues.filter(v => v != null);
  }

  async findAbout () {
    const baseRef = this.base();
    const aboutSS = await baseRef
      .collection("about")
      .doc("doc")
      .get();

    const data = aboutSS.data();
    return data;
  }

  async findSettings () {
    const settingsSS = await this.db.doc(`${this.rootDoc}/settings/doc`).get();
    return settingsSS.data();
  }

  //----------------------------------------
  //----------------------------------------
  async sleep (msec) {
    return new Promise(function (resolve) {
      setTimeout(resolve, msec);
    });
  }
}

import moment from "moment";

// エミュレータ接続
// const ENV = process.env.VUE_APP_NODE_ENV;
// if (ENV === "local") {
//   console.log("### emulator ###");
//   db.settings({
//     host: "localhost:8080",
//     ssl: false,
//   });
// }
export default FirestoreDao;
